module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mb-10",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticClass: "d-flex align-center justify-space-between px-3 pt-3 font-weight-600 font-size-18 border-bottom pb-3 mt-5"
  }, [_c('div', [_vm._v("Data Aktivitas Konsul")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex px-3 py-4 gap-10 border-bottom"
  }, [_c('v-select', {
    staticStyle: {
      "max-width": "20%"
    },
    attrs: {
      "items": _vm.filter,
      "item-text": "label",
      "item-value": "value",
      "placeholder": "Filter",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search_category),
      callback: function($$v) {
        _vm.search_category = $$v
      },
      expression: "search_category"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Ketik kata kunci dan tekan enter",
      "dense": "",
      "outlined": "",
      "small": "",
      "hide-details": "",
      "append-icon": "mdi-magnify"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSearchData(1)
      }
    },
    model: {
      value: (_vm.search_value),
      callback: function($$v) {
        _vm.search_value = $$v
      },
      expression: "search_value"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "max-width": "15%"
    },
    attrs: {
      "items": _vm.list_filter_status,
      "item-text": "label",
      "item-value": "value",
      "placeholder": "Pilih Status",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.onSearchData(1)
      }
    },
    model: {
      value: (_vm.filter_status),
      callback: function($$v) {
        _vm.filter_status = $$v
      },
      expression: "filter_status"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.data,
      "item-key": "id",
      "server-items-length": _vm.totalItems,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        'items-per-page-options': [10, 20, 50],
      },
      "page": _vm.page,
      "no-data-text": "Data konsultan tidak tersedia"
    },
    on: {
      "update:page": _vm.onSearchData,
      "update:items-per-page": _vm.onUpdatePerPages
    },
    scopedSlots: _vm._u([{
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-menu', {
          attrs: {
            "offset-y": "",
            "transition": "slide-y-transition"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-btn', _vm._g({
                attrs: {
                  "text": ""
                }
              }, on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('v-card', [_c('v-list', [_c('v-list-item-group', [_c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.viewChatDetail(item.id)
            }
          }
        }, [_c('v-list-item-title', {
          staticClass: "d-flex align-center gap-10"
        }, [_c('v-icon', {
          staticClass: "menu-icon",
          attrs: {
            "color": "blew"
          }
        }, [_vm._v("\n                                        mdi-message-outline\n                                    ")]), _vm._v("\n                                    Detail Chat\n                                ")], 1)], 1), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.openDialogTimeActive(item)
            }
          }
        }, [_c('v-list-item-title', {
          staticClass: "d-flex align-center gap-10"
        }, [_c('v-icon', {
          staticClass: "menu-icon",
          attrs: {
            "color": "blew"
          }
        }, [_vm._v("\n                                        mdi-timer-refresh-outline\n                                    ")]), _vm._v("\n                                    Update Active Time\n                                ")], 1)], 1), _vm._v(" "), _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.updateSyncActiveTime(item)
            }
          }
        }, [_c('v-list-item-title', {
          staticClass: "d-flex align-center gap-10"
        }, [_c('v-icon', {
          staticClass: "menu-icon",
          attrs: {
            "color": "blew"
          }
        }, [_vm._v("\n                                        mdi-timetable\n                                    ")]), _vm._v("\n                                    Sync Active Time\n                                ")], 1)], 1)], 1)], 1)], 1)], 1)]
      }
    }, {
      key: "item.detail",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "py-3"
        }, [_c('div', {
          staticClass: "font-size-12 grey--text"
        }, [_vm._v("Siswa")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.student_name))]), _vm._v(" "), (item.teacher_name) ? _c('div', {
          staticClass: "font-size-12 grey--text mt-3"
        }, [_vm._v("\n                    Konsultan\n                ")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.teacher_name) + " - " + _vm._s(item.subject_name))])])]
      }
    }, {
      key: "item.consul_time",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "py-3"
        }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.$moment(item.date)
          .tz("Asia/Jakarta")
          .format("YYYY-MM-DD HH:mm")) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "mt-2"
        }, [_c('div', {
          staticClass: "font-size-12 grey--text"
        }, [_vm._v("Waktu Mulai")]), _vm._v(" "), _c('div', [_vm._v("\n                        " + _vm._s(_vm.timeFormat(item.start_time)) + "\n                    ")])]), _vm._v(" "), _c('div', {
          staticClass: "mt-2"
        }, [_c('div', {
          staticClass: "font-size-12 grey--text"
        }, [_vm._v("Waktu Selesai")]), _vm._v(" "), _c('div', [_vm._v("\n                        " + _vm._s(_vm.timeFormat(item.end_time)) + "\n                    ")])])])]
      }
    }, {
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [(item.status === 'finished') ? _c('v-chip', {
          staticClass: "font-weight-600",
          attrs: {
            "small": "",
            "color": "#e2f5ea",
            "text-color": "#27ae60"
          }
        }, [_vm._v("\n                Finished\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'waiting') ? _c('v-chip', {
          staticClass: "font-weight-600",
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                Waiting\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'started') ? _c('v-chip', {
          staticClass: "font-weight-600",
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                Started\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'request') ? _c('v-chip', {
          staticClass: "font-weight-600",
          attrs: {
            "small": "",
            "color": "#e2f5ea",
            "text-color": "#00cf3f"
          }
        }, [_vm._v("\n                Request\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'timeout') ? _c('v-chip', {
          staticClass: "font-weight-600",
          attrs: {
            "small": "",
            "color": "#fbefb2",
            "text-color": "#f2af17"
          }
        }, [_vm._v("\n                Timeout\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'canceled') ? _c('v-chip', {
          staticClass: "font-weight-600",
          attrs: {
            "small": "",
            "color": "#ffcccf",
            "text-color": "#eb3123"
          }
        }, [_vm._v("\n                Canceled\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'interrupted') ? _c('v-chip', {
          staticClass: "font-weight-600",
          attrs: {
            "small": "",
            "color": "#ffcccf",
            "text-color": "#eb3123"
          }
        }, [_vm._v("\n                Interrupted\n            ")]) : _vm._e(), _vm._v(" "), (item.status === 'accepted') ? _c('v-chip', {
          staticClass: "font-weight-600",
          attrs: {
            "small": "",
            "color": "#e2f5ea",
            "text-color": "#27ae60"
          }
        }, [_vm._v("\n                Accepted\n            ")]) : _vm._e()]
      }
    }, {
      key: "item.active_time",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "font-size-12 grey--text"
        }, [_vm._v("DB Active Time")]), _vm._v(" "), _c('div', {
          staticClass: "font-weight-bold font-size-16",
          style: (("color:" + (item.row_color_status)))
        }, [_vm._v("\n                " + _vm._s(parseInt(item.total_active_time) > 0 ?
          item.total_active_time :
          "0.00") + "\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "font-size-12 grey--text mt-3"
        }, [_vm._v("Real Active Time")]), _vm._v(" "), _c('div', {
          staticClass: "font-weight-bold font-size-16",
          style: (("color:" + (item.row_color_status)))
        }, [_vm._v("\n                " + _vm._s(item.real_time_active) + "\n            ")])]
      }
    }, {
      key: "item.session",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "font-size-12 grey--text"
        }, [_vm._v("Durasi Konsul")]), _vm._v(" "), _c('div', {
          staticClass: "font-weight-bold font-size-16"
        }, [_vm._v("\n                " + _vm._s(parseInt(item.consul_duration) > 0 ?
          item.consul_duration.toFixed(2) :
          "0.00") + "\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "font-size-12 grey--text mt-3"
        }, [_vm._v("Jumlah Sesi")]), _vm._v(" "), _c('div', {
          staticClass: "font-weight-bold font-size-16"
        }, [_vm._v("\n                " + _vm._s(parseInt(item.total_session) > 0 ?
          item.total_session :
          "0.00") + "\n            ")])]
      }
    }, {
      key: "no-results",
      fn: function() {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('p', {
          staticClass: "mt-2"
        }, [_vm._v("Hasil pencarian tidak ditemukan.")])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.datatable),
      callback: function($$v) {
        _vm.datatable = $$v
      },
      expression: "datatable"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "300",
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogFormTimeActive),
      callback: function($$v) {
        _vm.dialogFormTimeActive = $$v
      },
      expression: "dialogFormTimeActive"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "font-size-16"
  }, [_vm._v("\n                Update Total Active Time\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "label": "Total Active Time",
      "maxlength": "8",
      "outlined": "",
      "dense": "",
      "rules": [_vm.onlyNumberAndDot]
    },
    model: {
      value: (_vm.total_active_form),
      callback: function($$v) {
        _vm.total_active_form = $$v
      },
      expression: "total_active_form"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "#f7f8fa",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogFormTimeActive = false
      }
    }
  }, [_vm._v("\n                    Batal\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blew",
      "depressed": "",
      "dark": "",
      "loading": _vm.loading_update
    },
    on: {
      "click": function($event) {
        return _vm.updateActiveTime()
      }
    }
  }, [_vm._v("\n                    Simpan\n                ")])], 1)], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b1fc2a8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Konsul/ConsulTimeActive.vue
// module id = 1659
// module chunks = 1